
export const host ="https://e-comerce-node.vercel.app";
export const PostGood=`${host}/admin/postgoods`
export const Getdashboard=`${host}/admin/getdashboard`
export const GetProducts=`${host}/admin/getproduct`
export const Deliver=`${host}/admin/deliver`